<template>
  <div class="video-card">
    <div class="video-card-image video-cover">
      <router-link class="play-icon" :to="'/video/'+video_id">
        <i class="fas fa-play-circle"></i>
      </router-link>

      <router-link :to="'/video/'+video_id">
        <div class="img-container">
          <img class="img-fluid cover-image-v" :src="image_src" alt ref="cov" />
        </div>
      </router-link>
      <div class="time">{{duration_human}}</div>
      <!-- TODO: currently time duration disabled -->
    </div>
    <div class="video-card-body">
      <div class="video-title">
        <!-- <a @click="gotovideo(video_id)">{{title_text}}</a> -->
        <router-link :to="'/video/'+video_id">{{title_text}}</router-link>
        <a></a>
      </div>
      <div class="video-page text-success">
        {{category}}
        <router-link
          :to="'/video/'+video_id"
          title
          data-placement="top"
          data-toggle="tooltip"
          data-original-title="Verified"
        >
          <i class="fas fa-check-circle text-success"></i>
        </router-link>
      </div>
      <div class="video-view">
        {{views}} views &nbsp;
        <i class="fas fa-calendar-alt"></i>
        {{local_post_time}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "videoinfocard",
  props: {
    title_text: String,
    v_id: String,
    sub_title_text: String,
    duration: Number,
    time_post: String,
    views: Number,
    category: String,
    image_src: {
      default: function() {
        return require("../img/v2.png");
      }
    },
    video_id: {
      type: String,
      default: "sdlashdsajk"
    }
  },
  computed: {
    local_post_time() {
      let dt = new Date(parseFloat(this.time_post));
      // console.log(dt);
      return dt.getFullYear() + "/" + (dt.getMonth() + 1) + "/" + dt.getDate();
    },
    duration_human() {
      if (typeof this.duration === String) {
        return this.duration;
      } else {
        let drt = new Date(this.duration * 1000).toISOString().substr(11, 8);
        return drt;
      }
    }
  },
  mounted() {
    let covimg = this.$refs.cov;
    covimg.style.height = Math.floor(covimg.width * 0.5625) + "px";
  }
  // methods: {
  //   gotovideo(v_id) {
  //     console.log("clicked " + v_id);
  //     this.$router.push({ path: "/video/" + v_id });
  //   }
  // }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// .img-container {
//   display: block;
//   height: 0;
//   padding-bottom: 56.25%;
//   overflow: hidden;
// }

.img-container {
  display: block;
  height: 0;
  padding-bottom: 56.25%;
  overflow: hidden;
}

[style*="--aspect-ratio"] {
  > :first-child {
    width: 100%;
  }
  > img {
    height: auto;
  }

  @supports (--a: b) {
    position: relative;
    &::before {
      content: "";
      display: block;
      padding-bottom: calc(100% / (var(--aspect-ratio)));
    }
    > :first-child {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
    }
  }
}
</style>
